import React, { useEffect } from "react";
import "./contactusbanner.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";
import { Helmet } from "react-helmet";

const ContactUsBanner = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="contactusbanner">
      <Helmet>
        <title>Contact Myths Egypt Tours | Plan Your Egypt Trip</title>
        <meta
          name="description"
          content="Get in touch with Myths Egypt Tours for custom tour packages, inquiries, and bookings. Let’s plan your dream trip to Egypt."
        />
        <meta
          name="keywords"
          content="contact Myths Egypt Tours, Egypt travel contact, plan Egypt trip"
        />
        <meta property="og:title" content="Contact Myths Egypt Tours | Plan Your Egypt Trip" />
        <meta
          property="og:description"
          content="Contact Myths Egypt Tours for information, support, or to book your next Egypt adventure."
        />
        <meta property="og:url" content="https://mythsegypttours.com/contact" />
        <meta property="og:image" content="https://mythsegypttours.com/og-image.jpg" />
      </Helmet>

      <Banner page="contact" />
    </section>
  );
};

export default ContactUsBanner;
